import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDevicePreviousSettings,
  fetchDeviceSettings,
  lockCurrentDeviceSettings,
  updateDeviceSettings
} from "../actions";
import {
  getDeviceSettings,
  getDeviceSettingsPrevious,
  getDeviceSettingsPreviousState,
  getDeviceSettingsState
} from "../selectors";

function useDeviceSettings(deviceId, { fetch = false, fetchPrevious = false } = {}) {
  const dispatch = useDispatch();

  const settings = useSelector(state => getDeviceSettings(state, deviceId));
  const previousSettings = useSelector(state => getDeviceSettingsPrevious(state, deviceId));
  const { loading, error, lastFetch } = useSelector(state => getDeviceSettingsState(state, deviceId)) || {};
  const { loading: loadingPrevious, error: errorPrevious, lastFetch: lastFetchPrevious } = useSelector(state => getDeviceSettingsPreviousState(state, deviceId)) || {};

  const fetchSettings = useCallback(() => {
    dispatch(fetchDeviceSettings({id: deviceId}));
  }, [deviceId, dispatch]);

  const fetchPreviousSettings = useCallback(() => {
    dispatch(fetchDevicePreviousSettings({id: deviceId}));
  }, [deviceId, dispatch]);

  const lockSettings = useCallback((validTo) => {
    dispatch(lockCurrentDeviceSettings({ id: deviceId }, validTo));
  }, [deviceId, dispatch]);

  const updateSettings = useCallback((data) => {
    dispatch(updateDeviceSettings({ id: deviceId }, data));
  }, [deviceId, dispatch]);

  useEffect(() => {
    if(fetch && deviceId) {
      fetchSettings();
    }
  }, [fetch, deviceId]);

  useEffect(() => {
    if(fetchPrevious && deviceId) {
      fetchPreviousSettings();
    }
  }, [fetchPrevious, deviceId]);

  return {
    loading,
    loadingPrevious,
    error,
    errorPrevious,
    lastFetch,
    lastFetchPrevious,
    settings,
    previousSettings,
    updateSettings,
    lockSettings,
  };
}

export default useDeviceSettings;
